import React from 'react';
import { Route, Switch } from 'react-router';
import { ConnectedRouter } from 'react-router-redux';

import { history } from './store';
import LoaderContainer from './containers/LoaderContainer';
import Callback from './components/auth/Callback';
import Login from './components/auth/Login';
import PrivateRoute from './components/auth/PrivateRoute';
import LoadingBar from './components/elements/LoadingBar';

const App = () => (
  <React.Fragment>
    <LoadingBar />
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/callback" component={Callback} />
        <PrivateRoute
          path="/:deviceId?/oat/:id"
          render={props => (
            <LoaderContainer
              key={props.match.params.deviceId}
              allowedRoles={[
                'Administrator',
                'Cabinet Operator',
                'Production Operator',
              ]}
              showOATResultPage={true}
              {...props}
            />
          )}
        />
        <PrivateRoute
          path="/:deviceId?"
          render={props => (
            <LoaderContainer
              key={props.match.params.deviceId}
              allowedRoles={['Administrator']}
              showOATResultPage={false}
              {...props}
            />
          )}
        />
      </Switch>
    </ConnectedRouter>
  </React.Fragment>
);

export default App;
